module.exports = __webpack_public_path__ + "img/logo_solyd.eb38191d.png";